<template>
    <div>
        <div v-if="list.length != 0">
            <div class="item" v-for="item in list" :key="item.id">
                <div>订单号：{{item.order_id}}</div>
                <div>充值金额：￥{{item.price}}</div>
                <div>充值时间：{{item.pay_time}}</div>
            </div>
        </div>
        <div v-else style="margin: 200px auto; text-align:center">暂无充值记录</div>
    </div>
</template>

<script>
import { getRechargeMsg } from "@api/user";
export default {
    data(){
        return{
            number:'',
            list:''
        }
    },

    mounted(){
        this.number = this.$route.params.num;
        this.rechargeMsg();
    },

    methods:{
        rechargeMsg(){
           this.$dialog.loading.open("加载中");
           getRechargeMsg(this.number).then(res=>{
                this.list = res.data
                this.$dialog.loading.close();
           }).catch((err) => {
               this.$dialog.loading.close();
               this.$dialog.error("出错了");
           });
       }
    },

    watch:{
        list(newVal,oldVal){
            newVal.forEach((val,key) => {
                var timelist = new Date(parseInt(val.pay_time)* 1000)
                var year = timelist.getFullYear();
                var month =timelist.getMonth() + 1;
                var day = timelist.getDate();
                var h = timelist.getHours();
                var s = timelist.getMinutes();
                var m = timelist.getSeconds();
                var times = year + "-" + month + "-" +day +" "+ h+":"+ s+":"+m;
                this.list[key].pay_time = times;
            });
        }
    }
}
</script>

<style scoped>
  .item{
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    line-height: 1.8;
    padding: 10px;
    margin: 10px;
    box-shadow: 6px 6px 6px #9e9b9b;
    background-color: darkseagreen;

  }  
</style>
